import css from 'styled-jsx/css';
import { phone, tablet, tablet_desktop } from '../../../styles/media';

export const styles = css`
  .BigProductCard__breadcrumbsContainer {
    margin-bottom: 16px;
    align-self: flex-start;
  }
  .BigProductCard__breadcrumbsContainer_marginBottomExtended {
    margin-bottom: 25px;
  }
  .BigProductCard {
    display: flex;
    align-items: stretch;
    justify-content: center;
    background-color: var(--colors-white);
    flex-direction: column;
    transition: opacity .3s;
    text-align: left;
  }
  .BigProductCard__afterTopInfoSlot {
    margin-bottom: 16px;
  }
  .BigProductCard_tintingMode {
    opacity: 0.5;
  }
  .BigProductCard_modalMode {
    border-radius: 15px;
  }
  .BigProductCard__content {
    align-self: flex-start;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 30px;
  }
  .BigProductCard__headerWrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    margin: 0 -40px;
    height: 0;
  }
  .BigProductCard__section {
    position: relative;
  }
  .BigProductCard__badges {
    position: absolute;
    top: 15px;
    left: 0;
    z-index: 1;
  }
  .BigProductCard__productFeedbackButtonBox {
    width: 100%;
    text-align: left;
    margin-bottom: 50px;
  }

  .BigProductCard__disclaimer {
    font-size: 12px;
    line-height: 18px;
    padding: 20px 0;
    border-top: 1px solid var(--colors-brandLightGrey1);
    color: var(--colors-darkenGrey1);
    margin-bottom: 0;
  }

  @media ${tablet} {
    .BigProductCard_modalMode {
      padding: 50px 20px 10px 20px;
    }
  }
  @media ${tablet_desktop} {
    .BigProductCard_modalMode {
      padding: 40px 40px 10px 40px;
    }
    .BigProductCard__section {
      margin-bottom: 6px;
      width: calc(50% - 15px);
    }
    .BigProductCard__section:nth-child(odd) {
      margin-right: 30px;
    }
  }

  @media ${phone} {
    .BigProductCard_modalMode {
      padding: 10px 10px 10px 10px;
    }
    .BigProductCard__section {
      width: 100%;
      margin-bottom: 30px;
    }

    .BigProductCard__disclaimer {
      padding: 20px 0 0;
    }
  }
  `;
